import { db } from "./config";

const convertSnapshotToList = (snapshot) => {
  const list = [];

  if (snapshot.exists()) {
    const snapshotsKeys = snapshot.val();
    for (let key in snapshotsKeys) {
      const object = {
        ...snapshotsKeys[key],
        key,
      };
      list.push(object);
    }
  }
  return list;
};

const getServices = async () => {
  const snapshots = await db.ref("services").once("value");
  return convertSnapshotToList(snapshots);
};

const getProducts = async () => {
  const snapshots = await db.ref("products").once("value");
  return convertSnapshotToList(snapshots);
};

const getImages = async () => {
  const snapshots = await db.ref("images").once("value");
  return convertSnapshotToList(snapshots);
};

const pushAll = (node, lista) => {
  for (let i of lista) {
    db.ref(node).push(i);
  }
};

export { getServices, pushAll, getProducts, getImages };
